export enum SearchCategory {
    WHO = 'Who',
    HOW = 'How',
    FILES= 'Other Sharepoint locations',
    RELEVENT_PROJECT = 'Relevant Projects',
    LEFT_MENU_APP = 'Left Menu Application',
    EXTERNAL_APP = 'External Application',
    APPLICATION = 'Application',
}
